module.exports = __webpack_public_path__ + "static/media/emptycartimg.4ffc5757.svg";